import { e as _inheritsLoose, d as _extends, c as _taggedTemplateLiteralLoose } from './chunk-eb25cfa0.js';
import { theme } from 'styled-tools';
import 'styled-components';
import styled from './styled.js';
import 'reuse';
import use from './use.js';
import { createElement, Component } from 'react';
import { string, func, number } from 'prop-types';
import './chunk-afcdbe83.js';
import './chunk-1128464e.js';
import './Box.js';
import '@emotion/is-prop-valid';
import 'react-dom';
import { a as hoist } from './chunk-0cd02bff.js';
import './chunk-11bd1c20.js';
import Hidden from './Hidden.js';
import 'constate';
import './chunk-061cef7c.js';
import { c as HiddenToggle, b as HiddenShow, a as HiddenHide } from './chunk-22b2fb47.js';
import { a as StepContainer, b as StepNext, c as StepPrevious } from './chunk-abdb64f9.js';

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StepComponent =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(StepComponent, _React$Component);

  function StepComponent(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    var _this$props = _this.props,
        register = _this$props.register,
        step = _this$props.step,
        order = _this$props.order;
    register(step, order);
    return _this;
  }

  var _proto = StepComponent.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _this$props2 = this.props,
        step = _this$props2.step,
        update = _this$props2.update,
        order = _this$props2.order;

    if (prevProps.step !== step || prevProps.order !== order) {
      update(prevProps.step, step, order);
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    var _this$props3 = this.props,
        step = _this$props3.step,
        unregister = _this$props3.unregister;
    unregister(step);
  };

  _proto.render = function render() {
    var _this$props4 = this.props,
        isCurrent = _this$props4.isCurrent,
        step = _this$props4.step;
    return createElement(Hidden, _extends({
      unmount: true,
      visible: isCurrent(step)
    }, this.props));
  };

  return StepComponent;
}(Component);

var Step = styled(hoist(StepComponent, Hidden))(_templateObject(), theme("Step")); // @ts-ignore

Step.propTypes = {
  step: string.isRequired,
  register: func.isRequired,
  update: func.isRequired,
  unregister: func.isRequired,
  isCurrent: func.isRequired,
  order: number
};
var Step$1 = use(Step, "div");

function _templateObject$1() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}

var toggle = function toggle(props) {
  return function () {
    return props.toggle && props.toggle(props.step);
  };
};

var StepToggleComponent = function StepToggleComponent(props) {
  return createElement(HiddenToggle, _extends({}, props, {
    toggle: toggle(props)
  }));
};

var StepToggle = styled(hoist(StepToggleComponent, HiddenToggle))(_templateObject$1(), theme("StepToggle")); // @ts-ignore

StepToggle.propTypes = {
  toggle: func.isRequired,
  step: string.isRequired
};
var StepToggle$1 = use(StepToggle, "button");

function _templateObject$2() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n"]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}

var show = function show(props) {
  return function () {
    return props.show && props.show(props.step);
  };
};

var StepShowComponent = function StepShowComponent(props) {
  return createElement(HiddenShow, _extends({}, props, {
    show: show(props)
  }));
};

var StepShow = styled(hoist(StepShowComponent, HiddenShow))(_templateObject$2(), theme("StepShow")); // @ts-ignore

StepShow.propTypes = {
  show: func.isRequired,
  step: string.isRequired
};
var StepShow$1 = use(StepShow, "button");

function _templateObject$3() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n"]);

  _templateObject$3 = function _templateObject() {
    return data;
  };

  return data;
}
var StepHide = styled(HiddenHide)(_templateObject$3(), theme("StepHide"));
var StepHide$1 = use(StepHide, "button");

var Step$2 = Object.assign(Step$1, {
  Container: StepContainer,
  Toggle: StepToggle$1,
  Show: StepShow$1,
  Hide: StepHide$1,
  Next: StepNext,
  Previous: StepPrevious
});

export default Step$2;
